import classes from './SideBar.module.css';
import side_bar_img from './images/side_bar.png'

function SideBarInactive(props) {



    let sidebar_collapsed = (<>
            <div style={{width: `${props.width}px`, height: '100%', margin:'0', padding:'0', overflow:'hidden'}}>
                <img className={classes.side_bar_img} style={{height: '100%'}} src={side_bar_img} alt="side_bar"/>
                <div className={classes.side_bar_img} style={{height: '100%', width:`${props.width - 17}px`, position:'absolute', opacity: '0.9', backgroundColor:'white'}} ></div>
            </div>
        </>);


    return (<> {sidebar_collapsed} </> );

}

export default SideBarInactive;